/**
 * Detects if the application is running on localhost
 * Used to enable token exchange mode instead of MSAL authentication
 */
export function isLocalhost(): boolean {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}
